import { ThemeOption } from '@helpers/brand';
import { imageUrl } from '@helpers/image';
import SvgHoverArrowRight from '@img/icons/hover-arrow-right.svg';
import React from 'react';
import { ImageText5050Styles as S } from './ImageText5050.styles';
export var ComponentLayoutWidth;
(function (ComponentLayoutWidth) {
    ComponentLayoutWidth["Default"] = "default";
    ComponentLayoutWidth["Reduced"] = "reduced";
})(ComponentLayoutWidth || (ComponentLayoutWidth = {}));
const ImageText5050 = ({ content, cta, heading, id, image, theme = ThemeOption.White, componentWidth = ComponentLayoutWidth.Default, }) => {
    return (React.createElement(S.Container, { id: id, innerWidth: componentWidth, theme: theme, flush: "top" },
        React.createElement(S.Inner, null,
            React.createElement(S.Text, null,
                !!heading && React.createElement(S.Heading, null, heading),
                React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                cta && cta.text && cta.url && (React.createElement(S.Link, { href: cta.url, target: cta.target ?? '_self', id: cta.id, title: cta.text, styleType: "text", addon: React.createElement(SvgHoverArrowRight, null) }))),
            React.createElement(S.ImageWrapper, null,
                React.createElement("img", { alt: image.altText, loading: "lazy", role: image.altText ? undefined : 'presentation', src: imageUrl(image, {}) })))));
};
export default ImageText5050;
